export default __webpack_public_path__ + "static/media/Chinedum Echendu.a45f1574.png";